__turbopack_context__.v({
  "wrap": "ComfortMortgageInfo-module-scss-module__duzryG__wrap",
});
